export const ACADEMY_CALENDAR_COLORS = [
  { value: "#b7dbc5", label: "초록" },
  { value: "#bbd4e8", label: "파랑" },
  { value: "#f3d19c", label: "주황" },
  { value: "#edb5b3", label: "빨강" },
  { value: "#ebbbd1", label: "핑크" }
];

const CURATED_EXAM_PERIOD_COLORS = [
  ...ACADEMY_CALENDAR_COLORS.map(({ value }) => value),
  "#c7bce7",
  "#afd9d5",
  "#d7dfa8",
  "#b7c4e5",
  "#e1c3a8",
  "#b6d8df",
  "#d5b9df"
];

function toHex(value) {
  return Math.round(value * 255).toString(16).padStart(2, "0");
}

function hslToHex(hue, saturation, lightness) {
  const s = saturation / 100;
  const l = lightness / 100;
  const chroma = (1 - Math.abs(2 * l - 1)) * s;
  const segment = ((hue % 360) + 360) % 360 / 60;
  const intermediate = chroma * (1 - Math.abs((segment % 2) - 1));
  const [red, green, blue] = segment < 1 ? [chroma, intermediate, 0]
    : segment < 2 ? [intermediate, chroma, 0]
      : segment < 3 ? [0, chroma, intermediate]
        : segment < 4 ? [0, intermediate, chroma]
          : segment < 5 ? [intermediate, 0, chroma]
            : [chroma, 0, intermediate];
  const match = l - chroma / 2;
  return "#" + toHex(red + match) + toHex(green + match) + toHex(blue + match);
}

export function getExamPeriodColor(index) {
  if (index < CURATED_EXAM_PERIOD_COLORS.length) return CURATED_EXAM_PERIOD_COLORS[index];
  const generatedIndex = index - CURATED_EXAM_PERIOD_COLORS.length;
  const hue = (258 + generatedIndex * 137.508) % 360;
  const saturationBands = [44, 52, 58];
  const lightnessBands = [78, 73, 81];
  const band = Math.floor(generatedIndex / 12) % saturationBands.length;
  const lightnessBand = Math.floor(generatedIndex / 4) % lightnessBands.length;
  return hslToHex(hue, saturationBands[band], lightnessBands[lightnessBand]);
}

function normalizeColor(color) {
  return String(color || "").trim().toLowerCase();
}

function findUnusedExamPeriodColor(usedColors, startIndex = 0) {
  for (let index = startIndex; index < startIndex + usedColors.size + 128; index += 1) {
    const color = getExamPeriodColor(index);
    if (!usedColors.has(normalizeColor(color))) return color;
  }
  return getExamPeriodColor(startIndex + usedColors.size + 128);
}

export function getNextExamPeriodColor(periods = []) {
  const usedColors = new Set(periods.map((period) => normalizeColor(period.color)).filter(Boolean));
  return findUnusedExamPeriodColor(usedColors);
}

export function normalizeExamPeriodColors(periods = []) {
  const knownColors = new Map();
  for (let index = 0; index < periods.length + 128; index += 1) {
    const color = getExamPeriodColor(index);
    knownColors.set(normalizeColor(color), color);
  }

  const usedColors = new Set();
  return periods.map((period) => {
    const normalizedCurrent = normalizeColor(period.color);
    const preservedColor = knownColors.get(normalizedCurrent);
    const color = preservedColor && !usedColors.has(normalizedCurrent)
      ? preservedColor
      : findUnusedExamPeriodColor(usedColors);
    usedColors.add(normalizeColor(color));
    return period.color === color ? period : { ...period, color };
  });
}
